
    <template>
      <div>
        <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

        <v-data-table
          :headers="headers"
          :items="mapafrequencia.items"      
          :sort-desc="true"      
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">            
              <v-row>
                <v-col cols="12" sm="4" md="4"> <v-toolbar-title>Mapa de Frequência dos estudantes</v-toolbar-title></v-col>
              <v-col cols="12" sm="4" md="4">
                  <v-select
                    :items="Listaranoslectivo"
                    v-model="anolectivo"
                    item-value="descricao"
                    item-text="novadescricao"
                    @change="carregarMapaFrequencia()"
                    label="Selecione o Ano lectivo"
                    outlined
                    return-object
                  ></v-select>      
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn large fab color="#006699" @click="comporHTML()"
                            :disabled="!mapafrequencia.items.length"
                              v-bind="attrs"
                              v-on="on"
                            >
                            <v-icon color="white" :disabled="!mapafrequencia.items.length">print</v-icon>
                              </v-btn>
                          </template>
                          <span>Clique aqui para visualizar o PDF</span>
                      </v-tooltip>
        </v-col>
    </v-row>
              <v-spacer></v-spacer>    
            </v-toolbar>
    </template>          
          <template v-slot:no-data>
            no data
          </template>
        </v-data-table>
      
         
      </div>
      </template>
<script>
import axios from '../../../../plugins/axios'
import impressao from '../../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    relatorio: '',
    mapafrequencia: {items:[],totais:null},
    html: ``,
    isLoading: true,
    Listaranoslectivo: [],
    anolectivo: null,
    headers: [
      {
        text: 'Curso',
        align: 'left',
        sortable: false,
        value: 'curso'
      },
      { text: 'Estudantes (10ª Classe)', value: 'aluno10' },
       { text: 'Estudantes (11ª Classe)', value: 'aluno11' },
      { text: 'Estudantes (12ª Classe)', value: 'aluno12' },
      { text: 'Estudantes (13ª Classe)', value: 'aluno13' },
      { text: 'Total', value: 'totalalunosclasses' }
    ],

  }),
  computed: {
  },
  watch: {
  },
  created  () {
    this.carregarRelatorio()   
    this.carregarAnosLectivo() 
  },
  methods: {
    async carregarAnosLectivo () {
      try {
        this.isLoading = true
        this.Listaranoslectivo = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar os anos lectivos' })    
        this.isLoading = false
      } finally {
        this.sair()
      }
    },
    async carregarRelatorio () {
      try {
        this.isLoading = true
        this.relatorio = await axios.get('/obterRelatorioByDescricao/mf').then(res => res.data) 
      } catch (error) {
        this.sair()
        Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar o relatório' })
      }
    },
    async carregarMapaFrequencia () {
      try {     
        this.isLoading = true   
        this.mapafrequencia = await axios.get('/getmapafrequencia/'+ this.anolectivo.descricao).then(res => res.data) 

      } catch (error) {
        this.sair()
        Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar o mapa de frequência' })
      } finally {
        this.sair()
      }
    },
    comporHTML () {
      try {
        this.isLoading = true
        this.html = this.relatorio[0].documento
        let documentoiter = this.relatorio[0].documentoiteracao1
        let header = this.relatorio[0].documentoiteracao2
        
        this.html = this.html.replace(/{{instituicaodescricao}}/g, ls.get('instituicaodescricao').toUpperCase())
        this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
        this.html = this.html.replace(/{{anolectivo}}/g, this.anolectivo.novadescricao)
        this.html = this.html.replace(/{{dataacual}}/g, this.correntDate()) 

        this.html = this.html.replace(/{{totalgeralturmas10}}/g, this.mapafrequencia.totais.classe10.turmas)
        this.html = this.html.replace(/{{totalgeralm10}}/g, this.mapafrequencia.totais.classe10.masc)
        this.html = this.html.replace(/{{totalgeralf10}}/g, this.mapafrequencia.totais.classe10.fem)
        this.html = this.html.replace(/{{totalgeral10}}/g, this.mapafrequencia.totais.classe10.total)

        this.html = this.html.replace(/{{totalgeralturmas11}}/g, this.mapafrequencia.totais.classe11.turmas)
        this.html = this.html.replace(/{{totalgeralm11}}/g, this.mapafrequencia.totais.classe11.masc)
        this.html = this.html.replace(/{{totalgeralf11}}/g, this.mapafrequencia.totais.classe11.fem)
        this.html = this.html.replace(/{{totalgeral11}}/g, this.mapafrequencia.totais.classe11.total)

        this.html = this.html.replace(/{{totalgeralturmas12}}/g, this.mapafrequencia.totais.classe12.turmas)
        this.html = this.html.replace(/{{totalgeralm12}}/g, this.mapafrequencia.totais.classe12.masc)
        this.html = this.html.replace(/{{totalgeralf12}}/g, this.mapafrequencia.totais.classe12.fem)
        this.html = this.html.replace(/{{totalgeral12}}/g, this.mapafrequencia.totais.classe12.total)
    
        this.html = this.html.replace(/{{totalgeralturmas13}}/g, this.mapafrequencia.totais.classe13.turmas)
        this.html = this.html.replace(/{{totalgeralm13}}/g, this.mapafrequencia.totais.classe13.masc)
        this.html = this.html.replace(/{{totalgeralf13}}/g, this.mapafrequencia.totais.classe13.fem)
        this.html = this.html.replace(/{{totalgeral13}}/g, this.mapafrequencia.totais.classe13.total)

        this.html = this.html.replace(/{{turmastotalgeral}}/g, parseInt(this.mapafrequencia.totais.classe10.turmas)+parseInt(this.mapafrequencia.totais.classe11.turmas)+parseInt(this.mapafrequencia.totais.classe12.turmas)+parseInt(this.mapafrequencia.totais.classe13.turmas))
        this.html = this.html.replace(/{{totalgeralm}}/g, parseInt(this.mapafrequencia.totais.classe10.masc)+parseInt(this.mapafrequencia.totais.classe11.masc)+parseInt(this.mapafrequencia.totais.classe12.masc)+parseInt(this.mapafrequencia.totais.classe13.masc))
        this.html = this.html.replace(/{{totalgeralf}}/g, parseInt(this.mapafrequencia.totais.classe10.fem)+parseInt(this.mapafrequencia.totais.classe11.fem)+parseInt(this.mapafrequencia.totais.classe12.fem)+parseInt(this.mapafrequencia.totais.classe13.fem))
        this.html = this.html.replace(/{{totalgeral}}/g, parseInt(this.mapafrequencia.totais.classe10.total)+parseInt(this.mapafrequencia.totais.classe11.total)+parseInt(this.mapafrequencia.totais.classe12.total)+parseInt(this.mapafrequencia.totais.classe13.total))

        let dados = ``

        this.mapafrequencia.items.forEach(element => {
          let iteracao = documentoiter
          iteracao = iteracao.replace(/{{curso}}/g, element.curso.toUpperCase())

          iteracao = iteracao.replace(/{{turmas10}}/g, element.qtdturma10)
          iteracao = iteracao.replace(/{{m10}}/g, element.alunomasc10)
          iteracao = iteracao.replace(/{{f10}}/g, element.alunofem10)
          iteracao = iteracao.replace(/{{total10}}/g, element.aluno10)

          iteracao = iteracao.replace(/{{turmas11}}/g, element.qtdturma11)
          iteracao = iteracao.replace(/{{m11}}/g, element.alunomasc11)
          iteracao = iteracao.replace(/{{f11}}/g, element.alunofem11)
          iteracao = iteracao.replace(/{{total11}}/g, element.aluno11)

          iteracao = iteracao.replace(/{{turmas12}}/g, element.qtdturma12)
          iteracao = iteracao.replace(/{{m12}}/g, element.alunomasc12)
          iteracao = iteracao.replace(/{{f12}}/g, element.alunofem12)
          iteracao = iteracao.replace(/{{total12}}/g, element.aluno12)
          
          iteracao = iteracao.replace(/{{turmas13}}/g, element.qtdturma13)
          iteracao = iteracao.replace(/{{m13}}/g, element.alunomasc13)
          iteracao = iteracao.replace(/{{f13}}/g, element.alunofem13)
          iteracao = iteracao.replace(/{{total13}}/g, element.aluno13)
    
          iteracao = iteracao.replace(/{{turmastotal}}/g, element.totalturmasclasses)
          iteracao = iteracao.replace(/{{mtotal}}/g, element.totalalunosmascclasses)
          iteracao = iteracao.replace(/{{ftotal}}/g, element.totalalunosfemclasses)
          iteracao = iteracao.replace(/{{totalgeralcurso}}/g, element.totalalunosclasses)
    
          dados += iteracao
      })
      this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
      this.html = this.html.replace(/{{dados}}/g, dados)
        let options = { 'format': 'A4',
        'orientation': 'landscape',
        'border': {
          'right': '12mm',
          'left': '12mm'
        },
        'header': {
          'height': '10mm',
          'contents': { first: header } },
        'footer': {
          'height': '10mm'

        } }
        impressao.htmlToPDF(this.html,options,ls.get('urlReport'),ls.get('idPessoa'))
      } catch (error) {
        this.sair()
        Swal.fire({icon: 'error',title: '', text: 'Ocorreu um erro ao abrir o documento'})
      } finally {
        this.sair()
      }
    },   
    sair(){ this.isLoading =false },
    correntDate () {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return 'Luanda, ' + data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString()
    }
  }
}

</script>
